import { render, staticRenderFns } from "./CustomPropertiesSelector.vue?vue&type=template&id=c1c5766a"
import script from "./CustomPropertiesSelector.vue?vue&type=script&lang=js"
export * from "./CustomPropertiesSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports